import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { CornerstoneService } from '@viewer/cornerstone.service';
import { ISliderSettings } from '@viewer/data';
import { PointerShape } from '../data';
import { ToolListService } from '../tool-list/tool-list.service';

@Component({
  selector: 'app-pointer-settings',
  templateUrl: 'pointer-settings.component.html',
  styleUrls: ['pointer-settings.component.scss'],
})
export class PointerSettingsComponent implements OnInit, OnDestroy {
  @Input() toolName = 'Brush';
  @Input() isToolActive = false;
  @Input() shape = PointerShape.Circle;
  @Input() size: number = this._cornerstoneService.getBrushSize();
  @Input() useHotKeys = true;

  @Output() shapeChange: EventEmitter<PointerShape> =
    new EventEmitter<PointerShape>();

  @Output() sizeChange: EventEmitter<number> = new EventEmitter<number>();

  public sliderSettings: ISliderSettings = {
    tickInterval: 1,
    step: 1,
    min: 1,
    max: 50,
  };

  private _unsubscribe$ = new Subject<void>();

  constructor(
    private _cornerstoneService: CornerstoneService,
    private _toolListService: ToolListService
  ) {}

  ngOnInit(): void {
    if (this.useHotKeys) {
      this._toolListService
        .getChangeToolSizeEvent()
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe((eventType) => {
          switch (eventType) {
            case 'INCREASE':
              this._increaseToolSize();
              break;
            case 'DECREASE':
              this._decreaseToolSize();
              break;
          }
        });
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  onSizeChanged(): void {
    this._cornerstoneService.setBrushSize(this.size);
    this.sizeChange.next(this.size);
  }

  isPointerShapeCircle(): boolean {
    return this.shape == PointerShape.Circle;
  }

  onSwitchBtnClick(isPointerShapeCircle: boolean): void {
    this.shape = isPointerShapeCircle
      ? PointerShape.Circle
      : (this.shape = PointerShape.Square);

    this.shapeChange.next(this.shape);
  }

  private _increaseToolSize(): void {
    if (!this.isToolActive || this.size >= this.sliderSettings.max) {
      return;
    }

    if (this.size + this.sliderSettings.step >= this.sliderSettings.max) {
      this.size = this.sliderSettings.max;
    } else {
      this.size += this.sliderSettings.step;
    }

    this.onSizeChanged();
  }

  private _decreaseToolSize(): void {
    if (!this.isToolActive || this.size <= this.sliderSettings.min) {
      return;
    }

    if (this.size - this.sliderSettings.step <= this.sliderSettings.min) {
      this.size = this.sliderSettings.min;
    } else {
      this.size -= this.sliderSettings.step;
    }

    this.onSizeChanged();
  }
}
